import { LT_SAVINGS_DATA_RECEIVED, LT_SAVINGS_UNLOADED, LT_SAVINGS_DATA_SAVED, LT_SAVINGS_DATA_DELETED } from './types'

// TODO: CREATE REDUCERS FOR SAVE AND DELETE
export default function savings(state = [], action = {}){
  switch (action.type) {
    case LT_SAVINGS_DATA_RECEIVED:
      return action.data.sort(function(a, b) {
        let result = 0 
        let aAlloc = parseFloat(a.allocation)
        let bAlloc = parseFloat(b.allocation)
        aAlloc += (aAlloc > 0 && aAlloc < 1) ? 0 : 1
        bAlloc += (bAlloc > 0 && bAlloc < 1) ? 0 : 1
        result = (bAlloc - aAlloc) || (a.itemType.localeCompare(b.itemType)) || (parseInt(a.balance, 10) - parseInt(b.balance, 10)) || (a.description.localeCompare(b.description))
        return result
      })
    case LT_SAVINGS_UNLOADED:
      return []
    case LT_SAVINGS_DATA_SAVED:
      let isEdit = false
      const _state = state.map( v => {
        if(v.id === action.data.id){
          isEdit = true
          return action.data
        }else{
          return v
        }
      })
      if(!isEdit){
        return [action.data, ...state]
      }else{
        return _state
      }
    case LT_SAVINGS_DATA_DELETED:
      return state.filter(v => v.id !== action.data.id)
    default:
      return state;
  }
}
